import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { applyUser } from 'reducers/auth';
import UINotifications from 'components/UI/Notifications';
import SignupForm from './Form';
import { setCookie } from 'helpers/cookies';
import { TOKEN_COOKIE_NAME } from 'helpers/constants';
import { useProductEvents } from 'hooks';
import API from 'api';
import { isProdAPI } from 'helpers/helpers';
import isEmpty from 'lodash/isEmpty';

const jwtDecode = require('jwt-decode');

function ConnectedSignUpForm(props) {
  const [loading, setLoading] = useState(false);
  const signup = useSelector(state => state.signup);
  const router = useRouter();
  const dispatch = useDispatch();
  const events = useProductEvents();

  const registerGarage = (model, city) => {
    let _model = { ...model };
    const timeZoneName = Intl?.DateTimeFormat().resolvedOptions().timeZone;

    if (timeZoneName) {
      _model.garage = {
        ...model.garage,
        email: model.employee?.email,
        phone: model.employee?.phone,
        settings: {
          timezone: {
            name: timeZoneName
          }
        }
      }
    }

    if (city) {
      _model.garage = { ...(_model.garage || {}), address: { city } }
    }

    delete _model.acceptOffer;

    return dispatch(
      API.mutations.registerGarage({ input: _model })
    )
      .then((res) => {
        const { token, actor } = res.data.registerGarage;
        const user = jwtDecode(token);

        setCookie(TOKEN_COOKIE_NAME, token, 30);
        dispatch(applyUser(user));
        setLoading(false);

        if (actor.phone) {
          events.setUser(actor.phone)
        }
        events.send('registration_success_workshop');

        //Отправка события регистрации в Facebook и Vk. Костыль на время, пока событие только одно.
        if (isProdAPI() && typeof window !== 'undefined') {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'CompleteRegistration');
          }

          if (window.VK && typeof window.VK.Goal === 'function') {
            window.VK.Goal('complete_registration');
          }
        }
        //---------------------------------------------------------------------

        events.send('open_workbench_desk_mp_workshop', { type: 'auth' })

        router.replace('/workbench?auth=just');
      })
      .catch(err => {
        debugger;
        setLoading(false);
        events.send('registration_fail_workshop', { error: { ...err.data } });

        if (!isEmpty(err.data)) {
          err.data.forEach(item => {
            UINotifications.show({
              type: 'danger',
              html: item.message
            });
          })
        }
      });
  }

  const register = async (model) => {
    setLoading(true);

    return fetch('/api/geo-ip')
      .then(res => res.json())
      .then(res => {
        return res.location?.data?.city;
      })
      .then(city => registerGarage(model, city))
      .catch(err => {
        console.log(err);
        setLoading(false);
      })
  };

  return (
    <SignupForm
      loading={loading || signup.loading}
      register={register}
      {...props}
    />
  )
}

export default ConnectedSignUpForm;